const postSSTData = (payload: Sst): void => {
  if (!(sstWorker instanceof Worker)) return;

  if (window.spsDataLayer?.logControl?.sstLogShow) console.log('sst:', payload.jsonPayload.eventType, payload.jsonPayload);

  sstWorker.postMessage(payload);
};

export { postSSTData };
